const addDataLayerTrigger = (name: string, props: any) => {
    if ('dataLayer' in window && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: name,
        ...props,
      });
    }
  };
  
  export default addDataLayerTrigger;
  